import { useState, FormEvent, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

export default function LoginPage() {
  const { user, initializing, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!initializing && user) navigate('/account');
  }, [user, initializing, navigate]);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/account');
    } catch (err: any) {
      setError(err.response?.data?.message || 'بيانات الدخول غير صحيحة');
    } finally {
      setLoading(false);
    }
  };

  if (initializing) {
    return (
      <main className="min-h-screen flex items-center justify-center bg-cream-50">
        <div className="text-center">
          <div className="animate-pulse w-12 h-12 bg-cream-200 rounded-full mx-auto mb-4" />
          <p className="text-charcoal-400 text-sm">جاري التحميل...</p>
        </div>
      </main>
    );
  }

  return (
    <main className="min-h-screen flex items-center justify-center bg-cream-50 py-12">
      <div className="w-full max-w-md mx-4">
        <div className="bg-white rounded-2xl border border-cream-300 shadow-sm p-8">
          <div className="text-center mb-8">
            <Link to="/" className="inline-block mb-4">
              <h2 className="text-2xl font-bold text-charcoal-900">سعاد الحاج</h2>
            </Link>
            <h1 className="text-xl font-bold text-charcoal-900 mb-1">تسجيل الدخول</h1>
            <p className="text-sm text-charcoal-500">مرحباً بعودتك! سجلي دخولك للمتابعة</p>
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg p-3 mb-6 text-right">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-charcoal-700 mb-1.5 text-right">البريد الإلكتروني</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                dir="ltr"
                className="w-full border border-cream-300 rounded-xl px-4 py-3 text-sm text-charcoal-900 placeholder:text-charcoal-400 focus:outline-none focus:border-blush-200 bg-cream-50"
                placeholder="email@example.com"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-charcoal-700 mb-1.5 text-right">كلمة المرور</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                dir="ltr"
                className="w-full border border-cream-300 rounded-xl px-4 py-3 text-sm text-charcoal-900 placeholder:text-charcoal-400 focus:outline-none focus:border-blush-200 bg-cream-50"
                placeholder="••••••••"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 bg-charcoal-900 text-white rounded-xl text-sm font-medium hover:bg-charcoal-800 transition-colors disabled:opacity-50"
            >
              {loading ? 'جاري تسجيل الدخول...' : 'تسجيل الدخول'}
            </button>
          </form>

          <p className="text-center text-sm text-charcoal-500 mt-6">
            ليس لديك حساب؟{' '}
            <Link to="/register" className="text-blush-200 hover:text-blush-300 font-medium">
              إنشاء حساب جديد
            </Link>
          </p>
        </div>
      </div>
    </main>
  );
}
